import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AuthContext, { RoleType } from "@contexts/auth-context";
import { createPopper } from "@popperjs/core";
import classNames from "classnames";
import Elevio from "elevio/lib/client";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef, useState } from "react";
import { articleDropdownList, conferenceDropdownList, loggedInBciqDropdownList, loggedOutBciqDropdownList } from "./header.constants";
var classes = "p-2 font-bold cursor-pointer hover:underline m-1";
var activeClass = "text-altPrimary underline bg-white";
var dropdownLinkClass = "block px-4 py-1 hover:text-white cursor-pointer";
var dropdownClass = "bg-primary2 text-simpleGray uppercase text-xs z-10";
var Header = function() {
    var currentUser = useContext(AuthContext);
    var isBCIQOrAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.customClaims.isBCIQ) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.customClaims.roles.includes(RoleType.Admin));
    var pathname = useRouter().pathname;
    var ref = useState(false), showArticleList = ref[0], setShowArticleList = ref[1];
    var ref1 = useState(false), showBciqList = ref1[0], setShowBciqList = ref1[1];
    var ref2 = useState(false), showConferencesList = ref2[0], setShowConferencesList = ref2[1];
    var articleLinkRef = useRef(null);
    var articleListRef = useRef(null);
    var bciqLinkRef = useRef(null);
    var bciqListRef = useRef(null);
    var conferencesLinkRef = useRef(null);
    var conferencesListRef = useRef(null);
    useEffect(function() {
        Elevio.load(process.env.NEXT_PUBLIC_ELEVIO_ACCOUNT_ID);
    }, []);
    var showArticleDropdown = function() {
        createPopper(articleLinkRef.current, articleListRef.current, {
            placement: "bottom-start"
        });
        setShowArticleList(true);
    };
    var hideArticleDropdown = function() {
        setShowArticleList(false);
    };
    var showBciqDropdown = function() {
        createPopper(bciqLinkRef.current, bciqListRef.current, {
            placement: "bottom-start"
        });
        setShowBciqList(true);
    };
    var hideBciqDropdown = function() {
        setShowBciqList(false);
    };
    var showConferencesDropdown = function() {
        createPopper(conferencesLinkRef.current, conferencesListRef.current, {
            placement: "bottom-start"
        });
        setShowConferencesList(true);
    };
    var hideConferencesDropdown = function() {
        setShowConferencesList(false);
    };
    var openWidget = function() {
        return Elevio.open();
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full overflow-x-auto whitespace-nowrap bg-altPrimary flex text-white uppercase pl-4 items-center justify-between py-2",
                children: [
                    /*#__PURE__*/ _jsxs("ul", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "/companies",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: classNames([
                                            classes,
                                            _define_property({}, activeClass, pathname.startsWith("/companies")), 
                                        ]),
                                        children: "Company Profiles"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "/targets",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: classNames([
                                            classes,
                                            _define_property({}, activeClass, pathname.startsWith("/targets")), 
                                        ]),
                                        children: "Target Profiles"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "/products",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: classNames([
                                            classes,
                                            _define_property({}, activeClass, pathname.startsWith("/products")), 
                                        ]),
                                        children: "Product Profiles"
                                    })
                                })
                            }),
                            isBCIQOrAdmin && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/diseases",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: classNames([
                                                    classes,
                                                    _define_property({}, activeClass, pathname.startsWith("/diseases")), 
                                                ]),
                                                children: "Disease Profiles"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/dealsearch",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: classNames([
                                                    classes,
                                                    _define_property({}, activeClass, pathname.startsWith("/dealsearch")), 
                                                ]),
                                                children: "Deal Profiles"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    currentUser && /*#__PURE__*/ _jsx("ul", {
                        className: "flex",
                        children: /*#__PURE__*/ _jsxs("li", {
                            children: [
                                /*#__PURE__*/ _jsx("a", {
                                    href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/users/report-saved"),
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: classes,
                                        children: "Saved Reports"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/users/alert-settings"),
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: classes,
                                        children: "My Alerts"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: classes,
                                    onClick: openWidget,
                                    children: "Help"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(dropdownClass, {
                    hidden: !showArticleList,
                    block: showArticleList
                }),
                onMouseEnter: showArticleDropdown,
                onMouseLeave: hideArticleDropdown,
                ref: articleListRef,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "py-1",
                    children: articleDropdownList.map(function(param) {
                        var id = param.id, href = param.href, text = param.text;
                        return /*#__PURE__*/ _jsx("a", {
                            className: dropdownLinkClass,
                            href: href,
                            children: text
                        }, id);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(dropdownClass, {
                    hidden: !showBciqList,
                    block: showBciqList
                }),
                onMouseEnter: showBciqDropdown,
                onMouseLeave: hideBciqDropdown,
                ref: bciqListRef,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-1",
                    children: [
                        !currentUser && loggedOutBciqDropdownList.map(function(param) {
                            var id = param.id, href = param.href, text = param.text;
                            return /*#__PURE__*/ _jsx(Link, {
                                href: href,
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: dropdownLinkClass,
                                    children: text
                                })
                            }, id);
                        }),
                        currentUser && loggedInBciqDropdownList.map(function(param) {
                            var id = param.id, href = param.href, text = param.text;
                            return /*#__PURE__*/ _jsx("a", {
                                className: dropdownLinkClass,
                                href: href,
                                children: text
                            }, id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(dropdownClass, {
                    hidden: !showConferencesList,
                    block: showConferencesList
                }),
                onMouseEnter: showConferencesDropdown,
                onMouseLeave: hideConferencesDropdown,
                ref: conferencesListRef,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "py-1",
                    children: conferenceDropdownList.map(function(param) {
                        var id = param.id, href = param.href, text = param.text;
                        return /*#__PURE__*/ _jsx("a", {
                            className: dropdownLinkClass,
                            href: href,
                            children: text
                        }, id);
                    })
                })
            })
        ]
    });
};
export default Header;
